<template>
  <div class="page-container">
    <el-card shadow="never" class="page-card">
      <div class="filter-bar">
        <div class="filter-group">
          <el-select
            v-model="query.categoryId"
            placeholder="全部分类"
            clearable
            filterable
            class="filter-select"
            :loading="categoriesLoading"
          >
            <el-option
              v-for="c in categories"
              :key="c.id"
              :label="c.name"
              :value="c.id"
            />
          </el-select>
          <el-select v-model="query.status" placeholder="全部状态" clearable class="filter-select-sm">
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
          <el-input
            v-model="query.name"
            placeholder="商品名称"
            prefix-icon="el-icon-search"
            clearable
            class="filter-input"
            @keyup.enter.native="handleSearch"
          />
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        </div>
        <div class="action-group">
          <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增商品</el-button>
          <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && tableData.length === 0" description="暂无商品" />

      <div v-else>
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          element-loading-text="加载中..."
          class="animate__animated animate__fadeIn"
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="72" align="center" />
          <el-table-column label="分类" width="100" align="center">
            <template slot-scope="scope">
              {{ categoryName(scope.row.categoryId || scope.row.category_id) }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip />
          <el-table-column label="图片" width="72" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="rowGoodsImage(scope.row)"
                :src="rowGoodsImage(scope.row)"
                fit="cover"
                lazy
                style="width:40px;height:40px;border-radius:4px;"
                :preview-src-list="[rowGoodsImage(scope.row)]"
              >
                <div slot="placeholder" class="img-placeholder"><i class="el-icon-loading"></i></div>
                <div slot="error" class="img-error"><i class="el-icon-picture-outline"></i></div>
              </el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column v-if="isShop" prop="priceCoins" label="金币价" width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.priceCoins != null ? scope.row.priceCoins : '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="isShop" prop="stock" label="库存" width="80" align="center" />
          <el-table-column v-if="!isShop" prop="shopUrl" label="购买链接" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <a v-if="scope.row.shopUrl || scope.row.shop_url" :href="scope.row.shopUrl || scope.row.shop_url" target="_blank" class="shop-link">{{ scope.row.shopUrl || scope.row.shop_url }}</a>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="88" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="small">上架</el-tag>
              <el-tag v-else type="info" size="small">下架</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="168" align="center">
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdTime || scope.row.created_time) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="openEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="dialogMode === 'add' ? '新增商品' : '编辑商品'"
      :visible.sync="dialogVisible"
      width="520px"
      center
      append-to-body
      @closed="onDialogClosed"
    >
      <el-form ref="goodsForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="分类" prop="categoryId">
          <el-select v-model="form.categoryId" placeholder="请选择分类" filterable style="width:100%;" :loading="categoriesLoading">
            <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="100" show-word-limit placeholder="商品名称" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model.trim="form.description" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="选填" />
        </el-form-item>
        <el-form-item label="商品主图">
          <div class="upload-row">
            <el-upload
              class="image-uploader"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              accept="image/*"
              :on-change="onGoodsFileChange"
              :before-upload="beforeImageUpload"
            >
              <img v-if="displayImageUrl" :src="displayImageUrl" class="image-uploader-thumb" alt="" />
              <i v-else class="el-icon-plus image-uploader-icon" />
            </el-upload>
            <el-button v-if="displayImageUrl" type="text" class="clear-img" @click="clearGoodsImage">清除图片</el-button>
          </div>
          <p class="upload-tip">选择图片后点击"确定"上传</p>
        </el-form-item>
        <el-form-item v-if="!isShop" label="购买链接" prop="shopUrl">
          <el-input v-model.trim="form.shopUrl" placeholder="请输入商品购买链接" />
        </el-form-item>
        <el-form-item v-if="isShop" label="金币价" prop="priceCoins">
          <el-input-number v-model="form.priceCoins" :min="0" :max="999999999" :step="100" controls-position="right" style="width:100%;" />
        </el-form-item>
        <el-form-item v-if="isShop" label="库存" prop="stock">
          <el-input-number v-model="form.stock" :min="0" :max="999999999" :step="1" controls-position="right" style="width:100%;" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, uploadShopImage } from '@/utils/http'
import { mallApi } from '@/api/mall'

export default {
  name: 'GoodsManagement',
  data() {
    return {
      loading: false,
      error: '',
      tableData: [],
      categories: [],
      categoriesLoading: false,
      query: {
        categoryId: null,
        status: null,
        name: ''
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogMode: 'add',
      submitLoading: false,
      configLoading: false,
      isShop: true,
      pendingFile: null,      // 待上传的文件对象
      previewUrl: '',         // 本地预览 URL
      form: {
        id: null,
        categoryId: null,
        name: '',
        description: '',
        imageUrl: '',
        shopUrl: '',
        priceCoins: 0,
        stock: 0,
        status: 1
      }
    }
  },
  computed: {
    displayImageUrl() {
      return this.previewUrl || this.form.imageUrl
    },
    rules() {
      const baseRules = {
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
      if (this.isShop) {
        // 自营商城：需要商品主图、金币价、库存
        return {
          ...baseRules,
          priceCoins: [{ required: true, message: '请输入价格', trigger: 'change' }],
          stock: [{ required: true, message: '请输入库存', trigger: 'change' }]
        }
      } else {
        // 外接商城：需要购买链接
        return {
          ...baseRules,
          shopUrl: [{ required: true, message: '请输入购买链接', trigger: 'blur' }]
        }
      }
    }
  },
  mounted() {
    this.fetchShopConfig()
    this.loadCategories()
    this.fetchList()
  },
  methods: {
    async fetchShopConfig() {
      this.configLoading = true
      try {
        const res = await get(mallApi.systemConfigPage, {
          configKey: 'is_shop',
          page: 1,
          pageSize: 1
        })
        const data = res.data || {}
        const records = Array.isArray(data.records) ? data.records : []
        if (records.length > 0) {
          const val = records[0].configValue
          this.isShop = val === 'true' || val === true
        } else {
          this.isShop = true
        }
      } catch (e) {
        console.error('获取商城配置失败，默认自营模式', e)
        this.isShop = true
      } finally {
        this.configLoading = false
      }
    },
    rowGoodsImage(row) {
      return row.imageUrl || row.image_url || ''
    },
    categoryName(categoryId) {
      if (categoryId == null) return '-'
      const cat = this.categories.find(c => c.id == categoryId)
      return cat ? cat.name : categoryId
    },
    beforeImageUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/bmp']
      const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp']

      if (!file.type || !allowedTypes.includes(file.type.toLowerCase())) {
        this.$message.error('不支持的文件类型，仅支持：jpg、jpeg、png、gif、webp、bmp')
        return false
      }

      const fileName = file.name.toLowerCase()
      const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext))
      if (!hasValidExtension) {
        this.$message.error('文件名无效，请确保文件有正确的扩展名')
        return false
      }

      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片大小不能超过10MB')
        return false
      }
      return true
    },
    onGoodsFileChange(file) {
      // 选文件后仅做本地预览，不立即上传
      this.pendingFile = file.raw
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl)
      }
      this.previewUrl = URL.createObjectURL(file.raw)
    },
    clearGoodsImage() {
      this.pendingFile = null
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl)
        this.previewUrl = ''
      }
      this.form.imageUrl = ''
    },
    async loadCategories() {
      this.categoriesLoading = true
      try {
        const res = await get(mallApi.categoryList)
        const raw = res.data
        this.categories = Array.isArray(raw) ? raw : []
      } catch (e) {
        console.error(e)
        this.$message.warning('加载分类失败，请先在「分类管理」维护分类')
        this.categories = []
      } finally {
        this.categoriesLoading = false
      }
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }
        if (this.query.categoryId != null && this.query.categoryId !== '') params.categoryId = this.query.categoryId
        if (this.query.status != null && this.query.status !== '') params.status = this.query.status
        if (this.query.name && this.query.name.trim()) params.name = this.query.name.trim()

        const res = await get(mallApi.goodsPage, params)
        const data = res.data || {}
        this.tableData = Array.isArray(data.records) ? data.records : []
        this.pagination.total = typeof data.total === 'number' ? data.total : 0
        if (data.current) this.pagination.pageNum = data.current
      } catch (e) {
        console.error(e)
        this.error = e.message || '加载商品失败'
        this.tableData = []
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchList()
    },
    refreshList() {
      this.query = { categoryId: null, status: null, name: '' }
      this.pagination.pageNum = 1
      this.loadCategories()
      this.fetchList()
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchList()
    },
    openAdd() {
      this.dialogMode = 'add'
      this.form = {
        id: null,
        categoryId: this.categories[0] ? this.categories[0].id : null,
        name: '',
        description: '',
        imageUrl: '',
        shopUrl: '',
        priceCoins: 0,
        stock: 0,
        status: 1
      }
      this.clearGoodsImage()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.goodsForm && this.$refs.goodsForm.clearValidate())
    },
    async openEdit(row) {
      this.dialogMode = 'edit'
      this.clearGoodsImage()
      this.dialogVisible = true
      try {
        const res = await get(mallApi.goodsDetail(row.id))
        const d = res.data || row
        this.form = {
          id: d.id ?? row.id,
          categoryId: row.categoryId ?? row.category_id ?? d.categoryId ?? d.category_id,
          name: row.name || d.name || '',
          description: row.description || d.description || '',
          imageUrl: row.imageUrl || row.image_url || d.imageUrl || d.image_url || '',
          shopUrl: row.shopUrl || row.shop_url || d.shopUrl || d.shop_url || '',
          priceCoins: row.priceCoins ?? row.price_coins ?? d.priceCoins ?? d.price_coins ?? 0,
          stock: row.stock ?? d.stock ?? 0,
          status: row.status ?? d.status ?? 1
        }
      } catch (e) {
        this.form = {
          id: row.id,
          categoryId: row.categoryId ?? row.category_id,
          name: row.name || '',
          description: row.description || '',
          imageUrl: row.imageUrl || row.image_url || '',
          shopUrl: row.shopUrl || row.shop_url || '',
          priceCoins: row.priceCoins ?? row.price_coins ?? 0,
          stock: row.stock ?? 0,
          status: row.status ?? 1
        }
        this.$message.warning('拉取详情失败，已使用列表行数据编辑')
      }
      this.$nextTick(() => this.$refs.goodsForm && this.$refs.goodsForm.clearValidate())
    },
    onDialogClosed() {
      this.submitLoading = false
    },
    submitForm() {
      this.$refs.goodsForm.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          // 如果有待上传的新文件，先上传
          if (this.pendingFile) {
            const url = await uploadShopImage(mallApi.goodsUploadImage, this.pendingFile)
            this.form.imageUrl = url
            this.pendingFile = null
            if (this.previewUrl) {
              URL.revokeObjectURL(this.previewUrl)
              this.previewUrl = ''
            }
          }
          const payload = {
            categoryId: this.form.categoryId,
            name: this.form.name,
            description: this.form.description || undefined,
            imageUrl: this.form.imageUrl || undefined,
            shopUrl: this.form.shopUrl || undefined,
            priceCoins: this.form.priceCoins,
            stock: this.form.stock,
            status: this.form.status
          }
          if (this.dialogMode === 'add') {
            await post(mallApi.goodsAdd, payload)
            this.$message.success('新增成功')
          } else {
            payload.id = this.form.id
            await put(mallApi.goodsUpdate, payload)
            this.$message.success('更新成功')
          }
          this.dialogVisible = false
          await this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '提交失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定永久删除商品「${row.name}」？不可恢复`, '提示', {
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      })
        .then(async () => {
          await del(mallApi.goodsDelete(row.id))
          this.$message.success('已删除')
          if (this.tableData.length === 1 && this.pagination.pageNum > 1) {
            this.pagination.pageNum -= 1
          }
          await this.fetchList()
        })
        .catch(() => {})
    },
    formatDate(val) {
      if (!val) return '-'
      const d = new Date(val)
      if (Number.isNaN(d.getTime())) return String(val)
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 16px;
}
.page-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  background: #fafafa;
  border-radius: 6px;
  margin-bottom: 16px;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.filter-select {
  width: 160px;
}
.filter-select-sm {
  width: 120px;
}
.filter-input {
  width: 180px;
}
.action-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.error {
  color: #f56c6c;
  padding: 16px;
  text-align: center;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.upload-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.clear-img {
  padding: 0;
  margin-bottom: 8px;
}
.upload-tip {
  margin: 6px 0 0;
  font-size: 12px;
  color: #909399;
}
.image-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}
.image-uploader ::v-deep .el-upload:hover {
  border-color: #409eff;
}
.image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  display: block;
}
.image-uploader-thumb {
  width: 120px;
  height: 120px;
  display: block;
  object-fit: cover;
}
.img-placeholder,
.img-error {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 4px;
  color: #dcdfe6;
  font-size: 16px;
}
.shop-link {
  color: #409EFF;
  text-decoration: none;
}
.shop-link:hover {
  text-decoration: underline;
}
</style>
